/// <reference types="@angular/localize" />

import { registerLocaleData } from '@angular/common';
import localeEsCl from '@angular/common/locales/es-CL';
import { bootstrapApplication } from '@angular/platform-browser';

registerLocaleData(localeEsCl, 'es-CL');

import { AppComponent } from '@infra-ui/app.component';
import { appConfig } from '@infra-ui/app.config';

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));

